module.exports = __webpack_public_path__ + "static/media/fail.14d1fd33.mp3";